export default class Journal {
    constructor() {
        this.selectors = {
            sideSectionList: '.journal-side-section',
            sideSectionListItem: 'li',
            liAnchor: 'a',
            tocAbstractPreview: '.top-content .abstract-preview',
        };
        this.elements = {
            tocAbstractPreview: Array.from(document.querySelectorAll(this.selectors.tocAbstractPreview)),
        };
        this.sideSectionList = [];
        this.classes = {
            show: 'js--show',
            mailIcon: 'icon-email-plus',
            cloned: 'cloned',
        };
        // this.init();
        // this.onLoad();
    }

    init() {
        this.sideSectionList = this.convertToArray(document.querySelectorAll(this.selectors.sideSectionList));
        if (!this.sideSectionList.length) {
            return;
        }
        this.sideSectionList.forEach(item => {
            item.classList.add(this.classes.show);
            const sideSectionLi = item.querySelectorAll(this.selectors.sideSectionListItem);

            this.convertToArray(sideSectionLi).forEach(this.sideSectionLiProcess);
        });
    }

    convertToArray = nodeList => Array.prototype.slice.call(nodeList);

    sideSectionLiProcess = li => {
        let liText = li.textContent.toLowerCase();

        if (liText.indexOf('get content alerts') > -1) {
            let liAnchor = li.querySelector('a'),
                href = liAnchor.getAttribute('href'),
                parent = li.parentElement;

            parent.insertAdjacentHTML('afterbegin', this.getLiNewContent(li, href));
            parent.removeChild(li);
        }
    };

    onLoad() {
        if (this.elements.tocAbstractPreview.length) {
            UX.utils.changeImageWidthOnLoad(this.selectors.tocAbstractPreview, 1.75);
        }
    }

    getLiNewContent(li, href) {
        return `<li id="Getcontentalerts" ${
            li.classList.contains(this.classes.cloned) ? `class="${this.classes.cloned}"` : ''
        }>
                    <a href="${href}" class="contentAlertLink">
                        <i aria-hidden="true" class="${this.classes.mailIcon}"></i>
                        <span>Sign up for email alerts</span>
                    </a>
                </li>`;
    }
}
